/**
 * @param filename {string}
 * @return {*|string}
 */
export function getFileExtension(filename) {
  return filename.replace(/.*\.([^.]+)$/, '$1').toUpperCase();
}

export const mapSupportedFiles = {
  AVI: 'video/avi',
  MP4: 'video/mp4',
  MPG: 'video/mpeg',
  MPEG: 'video/mpeg',
  WEBM: 'video/webm',
  OGV: 'video/ogg',
  MOV: 'video/quicktime',
  MKV: 'video/x-matroska',
  WMV: 'video/x-ms-wmv',
  FLV: 'video/x-flv',
  ASF: 'video/x-ms-asf',
  '3GP': 'video/3gpp',
  '3G2': 'video/3gpp2',
  DV: 'video/x-dv',
  M4V: 'video/mp4',
  MXF: 'application/mxf',
  JPG: 'image/jpeg',
  JPEG: 'image/jpeg',
  BMP: 'image/bmp',
  GIF: 'image/gif',
  PNG: 'image/png',
  MTS: 'video/mp2t',
  WAV: 'audio/wav',
  MP3: 'audio/mpeg',
  M4A: 'audio/x-m4a',
  WEBP: 'image/webp',
  AVIF: 'image/avif',
};

/**
 * @param extension {string}
 * @return {string}
 */
export function extensionToMimeType(extension) {
  return mapSupportedFiles[extension] || '';
}

export const mimeType = {
  isVideo(type) {
    return /^video|^application\/mxf$/i.test(type);
  },

  isImage(type) {
    return /^image/i.test(type);
  },

  isAudio(type) {
    return /^audio/i.test(type);
  },
};
